// extracted by mini-css-extract-plugin
module.exports = {"lg":"Paragraph_lg__tNNam","textCenter":"Paragraph_textCenter__B7izt"};